import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { OsobaEmail } from './osoba-email';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-osoba-email-modal-update',
  templateUrl: './osoba-email-modal-update.component.html'
})
export class OsobaEmailModalUpdateComponent
 extends BaseModalUpdateComponent<OsobaEmail>
 implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<OsobaEmail>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) { 
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
